(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@duik/form-group"), require("@duik/dropdown"), require("@duik/content-title"), require("@duik/text-field"));
	else if(typeof define === 'function' && define.amd)
		define(["@duik/form-group", "@duik/dropdown", "@duik/content-title", "@duik/text-field"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("@duik/form-group"), require("@duik/dropdown"), require("@duik/content-title"), require("@duik/text-field")) : factory(root["@duik/form-group"], root["@duik/dropdown"], root["@duik/content-title"], root["@duik/text-field"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__8__, __WEBPACK_EXTERNAL_MODULE__12__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 76);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__12__;

/***/ }),

/***/ 14:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getOptionLabel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDisplayValue; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(154);
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_1__);


var getOptionLabel = function (option) {
    if (option) {
        return option.label || option.value;
    }
    return null;
};
var getDisplayValue = function (option) {
    if (Array.isArray(option)) {
        if (option.length > 1) {
            return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment, null,
                getOptionLabel(option[0]),
                " ",
                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", { className: _styles_scss__WEBPACK_IMPORTED_MODULE_1___default.a["select-multi-count"] },
                    "+",
                    option.length - 1)));
        }
        return getOptionLabel(option[0]);
    }
    return getOptionLabel(option);
};


/***/ }),

/***/ 154:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"select":"select","dropdown-item":"dropdown-item","select-multi-count":"select-multi-count","select-option-selected-mark":"select-option-selected-mark","select-search-box":"select-search-box","select-search-input":"select-search-input","search-wrapper":"search-wrapper","select-search":"select-search","select-search-circle":"select-search-circle","select-search-rectangle":"select-search-rectangle"};

/***/ }),

/***/ 17:
/***/ (function(module, exports) {



/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__3__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),

/***/ 52:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectButton; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _duik_dropdown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _duik_dropdown__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_duik_dropdown__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};



var SelectButton = function (props) {
    var children = props.children, placeholder = props.placeholder, activeOption = props.activeOption, options = props.options, rest = __rest(props, ["children", "placeholder", "activeOption", "options"]);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_duik_dropdown__WEBPACK_IMPORTED_MODULE_1__["DropdownButton"], __assign({}, rest), children || Object(_utils__WEBPACK_IMPORTED_MODULE_2__[/* getDisplayValue */ "a"])(activeOption) || placeholder));
};


/***/ }),

/***/ 76:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Select", function() { return Select; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _duik_dropdown__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5);
/* harmony import */ var _duik_dropdown__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_duik_dropdown__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _duik_text_field__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12);
/* harmony import */ var _duik_text_field__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_duik_text_field__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _duik_content_title__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8);
/* harmony import */ var _duik_content_title__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_duik_content_title__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _duik_form_group__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3);
/* harmony import */ var _duik_form_group__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_duik_form_group__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14);
/* harmony import */ var _SelectButton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52);
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(154);
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_types__WEBPACK_IMPORTED_MODULE_9__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _types__WEBPACK_IMPORTED_MODULE_9__) if(["Select","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _types__WEBPACK_IMPORTED_MODULE_9__[key]; }) }(__WEBPACK_IMPORT_KEY__));
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (undefined && undefined.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};










var Select = function (props) {
    var options = props.options, activeOptionProp = props.activeOption, defaultOption = props.defaultOption, _a = props.placeholder, placeholder = _a === void 0 ? "Select Option" : _a, onOptionClick = props.onOptionClick, name = props.name, _b = props.inputSearchProps, inputSearchProps = _b === void 0 ? {} : _b, _c = props.searchable, searchable = _c === void 0 ? false : _c, buttonProps = props.buttonProps, multiple = props.multiple, className = props.className, label = props.label, noWrap = props.noWrap, rest = __rest(props, ["options", "activeOption", "defaultOption", "placeholder", "onOptionClick", "name", "inputSearchProps", "searchable", "buttonProps", "multiple", "className", "label", "noWrap"]);
    var _d = react__WEBPACK_IMPORTED_MODULE_0___default.a.useState(defaultOption), innerActiveOption = _d[0], setInnerActiveOption = _d[1];
    var getActiveOption = function () {
        if (activeOptionProp || activeOptionProp === null) {
            return activeOptionProp;
        }
        return innerActiveOption;
    };
    var activeOption = getActiveOption();
    var setOption = function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        if (onOptionClick) {
            onOptionClick.apply(void 0, params);
        }
        var option = params[0];
        if (multiple === true) {
            if (Array.isArray(innerActiveOption)) {
                var isSelected = innerActiveOption.findIndex(function (item) { return item.value === option.value; }) > -1;
                if (isSelected) {
                    // filtering out
                    var filtered = innerActiveOption.filter(function (item) { return item.value === option.value; });
                    setInnerActiveOption(filtered);
                }
                else {
                    // adding to selected options
                    setInnerActiveOption(__spreadArrays(innerActiveOption, [
                        option
                    ]));
                }
            }
            else {
                setInnerActiveOption([option]);
            }
        }
        else {
            setInnerActiveOption(option);
        }
    };
    var el = (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment, null,
        label && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_duik_content_title__WEBPACK_IMPORTED_MODULE_4__["ContentTitle"], null, label),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_duik_dropdown__WEBPACK_IMPORTED_MODULE_2__["Dropdown"], __assign({ className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_8___default.a["select"], className), ButtonComponent: _SelectButton__WEBPACK_IMPORTED_MODULE_7__[/* SelectButton */ "a"], buttonProps: __assign(__assign({}, buttonProps), { options: options,
                activeOption: activeOption,
                placeholder: placeholder }) }, rest), function (_a) {
            var handleClose = _a.handleClose, isOpen = _a.isOpen;
            var handleOptionClick = function (option) { return function () {
                setOption(option, name);
                if (!multiple) {
                    handleClose();
                }
            }; };
            return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment, null,
                searchable && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: _styles_scss__WEBPACK_IMPORTED_MODULE_8___default.a["select-search-box"] },
                    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_duik_text_field__WEBPACK_IMPORTED_MODULE_3__["TextField"], __assign({}, inputSearchProps, { autoFocus: true, className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_styles_scss__WEBPACK_IMPORTED_MODULE_8___default.a["select-search-input"], inputSearchProps.className), rightEl: react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: _styles_scss__WEBPACK_IMPORTED_MODULE_8___default.a["select-search-wrapper"] },
                            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: _styles_scss__WEBPACK_IMPORTED_MODULE_8___default.a["select-search"] },
                                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: _styles_scss__WEBPACK_IMPORTED_MODULE_8___default.a["select-search-circle"] }),
                                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: _styles_scss__WEBPACK_IMPORTED_MODULE_8___default.a["select-search-rectangle"] }))) })))),
                options.map(function (option) { return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_duik_dropdown__WEBPACK_IMPORTED_MODULE_2__["DropdownItem"], __assign({ onClick: handleOptionClick(option), key: option.value }, option.props),
                    Object(_utils__WEBPACK_IMPORTED_MODULE_6__[/* getDisplayValue */ "a"])(option),
                    multiple &&
                        Array.isArray(activeOption) &&
                        activeOption.find(function (item) { return item.value === option.value; }) && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", { className: _styles_scss__WEBPACK_IMPORTED_MODULE_8___default.a["select-option-selected-mark"] })))); })));
        })));
    return label && !noWrap ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_duik_form_group__WEBPACK_IMPORTED_MODULE_5__["FormGroup"], null, el) : el;
};


/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8__;

/***/ })

/******/ });
});